/* eslint-disable no-debugger */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import moment from "moment";
import {
  notification,
  Spin,
  Select,
  Input,
  Empty,
  Modal
} from "antd";
import {
  HiOutlineChevronLeft,
  HiOutlineUser,
  HiOutlinePhone,
  HiOutlineCheckCircle,
  HiOutlineSearch
} from 'react-icons/hi';
import Cookies from "js-cookie";

const { Option } = Select;

function WalkInBookingComponent() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [bookingLoading, setBookingLoading] = useState(false);

  // Data states
  const [doctors, setDoctors] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [services, setServices] = useState([]);
  const [slots, setSlots] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedDateStr, setSelectedDateStr] = useState(moment().format("YYYY-MM-DD"));
  const [selectedSlot, setSelectedSlot] = useState(null);

  // Patient states & search
  const [patientName, setPatientName] = useState("");
  const [patientPhone, setPatientPhone] = useState("");
  const [patientAge, setPatientAge] = useState("");
  const [gender, setGender] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [showSearchResults, setShowSearchResults] = useState(false);

  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    fetchDoctors();
  }, []);

  useEffect(() => {
    if (selectedDoctor) {
      fetchServices();
    }
  }, [selectedDoctor]);

  useEffect(() => {
    if (selectedDoctor && selectedService) {
      fetchSlots();
    }
  }, [selectedService, selectedDateStr, selectedDoctor]);

  const fetchDoctors = async () => {
    setLoading(true);
    try {
      const clinicId = Cookies.get("Clinic_id");
      const response = await axiosInstance.post("doctor/getClinicWiseDoctor", { clinic_id: clinicId });
      if (response.data.status === 1 && Array.isArray(response.data.data)) {
        setDoctors(response.data.data);
        const savedDoctorId = Cookies.get("Doctor_id");
        const initialDoctor = response.data.data.find(d => d.doctor_id === savedDoctorId) || response.data.data[0];
        if (initialDoctor) {
          setSelectedDoctor(initialDoctor);
        }
      }
    } catch (err) {
      console.error("Failed to fetch doctors", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchServices = async () => {
    if (!selectedDoctor) return;
    setLoading(true);
    try {
      const doctorId = selectedDoctor.doctor_id || Cookies.get("Doctor_id");
      const specialityId = selectedDoctor.specialityid || Cookies.get("speciality_Id");

      const response = await axiosInstance.post("doctor/getDoctorServiceBySpecilaity", {
        doctor_id: doctorId,
        speciality_id: specialityId
      });

      if (response.data.status === 1) {
        const activeServices = (response.data.data || []).filter(s => s.is_active == 1);
        setServices(activeServices);
        if (activeServices.length > 0 && !selectedService) {
          setSelectedService(activeServices[0]);
        }
      }
    } catch (error) {
      console.error("Failed to fetch services", error);
      notification.error({ message: "Failed to load services" });
    } finally {
      setLoading(false);
    }
  };

  const handlePatientSearch = async (val) => {
    const cleaned = (val || "").trim();
    if (!cleaned) {
      setSearchResults([]);
      setShowSearchResults(false);
      return;
    }
    setIsSearching(true);
    try {
      const clinicId = Cookies.get("Clinic_id") || 0;
      const res = await axiosInstance.post("doctor/getPatientSearch", {
        search_term: cleaned,
        clinic_id: clinicId
      });
      if (res.data?.status === 1 && Array.isArray(res.data.data)) {
        setSearchResults(res.data.data);
        setShowSearchResults(true);
      } else {
        setSearchResults([]);
      }
    } catch (err) {
      console.error("Patient search error:", err);
    } finally {
      setIsSearching(false);
    }
  };

  const selectExistingPatient = (patient) => {
    if (patient.patient_name || patient.name) setPatientName(patient.patient_name || patient.name);
    if (patient.patient_mobile || patient.phone_no) setPatientPhone(patient.patient_mobile || patient.phone_no);
    if (patient.gender) {
      const g = String(patient.gender).toUpperCase();
      setGender(g.startsWith('F') ? 'F' : 'M');
    }
    if (patient.age) setPatientAge(String(patient.age));
    setShowSearchResults(false);
  };

  const handlePhoneChange = (val) => {
    const cleaned = val.replace(/\D/g, '');
    setPatientPhone(cleaned);
    if (cleaned.length >= 3) {
      handlePatientSearch(cleaned);
    } else {
      setShowSearchResults(false);
    }
  };

  const fetchSlots = async () => {
    if (!selectedDoctor || !selectedService) return;
    setLoading(true);
    try {
      const response = await axiosInstance.post("doctor/getslotsbyservice", {
        search_date: selectedDateStr,
        clinic_id: Cookies.get("Clinic_id"),
        doctor_id: selectedDoctor.doctor_id,
        service_id: selectedService.id,
        type: "",
        nxtdate: "false"
      });

      if (response.data.status === 1 && response.data.data?.[0]?.date_slots) {
        const allSlots = response.data.data[0].date_slots;
        const isToday = selectedDateStr === moment().format("YYYY-MM-DD");
        const nowTime = moment();

        const processedSlots = allSlots.map(s => {
          const isWalkin = (s.appointtype_id == "1" || s.appointtype_id == "3");
          const isBooked = s.is_booked != 0 || s.is_blocked == "1";
          const isPast = isToday && moment(s.from_time, "HH:mm:ss").isBefore(nowTime, 'minute');
          const disabled = !isWalkin || isBooked || isPast;
          return {
            ...s,
            disabled,
            reason: isBooked ? 'Booked' : isPast ? 'Past' : ''
          };
        });
        setSlots(processedSlots);
      } else {
        setSlots([]);
      }
    } catch (error) {
      console.error("Failed to fetch slots", error);
    } finally {
      setLoading(false);
    }
  };

  const handleBooking = async () => {
    if (!selectedService || !selectedSlot || !patientName || !patientPhone || !gender || !patientAge) {
      notification.warning({ message: "Please fill all required fields, including Patient Age" });
      return;
    }

    if (patientPhone.length < 8) {
      notification.warning({ message: "Please enter a valid mobile number" });
      return;
    }

    if (Number(patientAge) <= 0 || isNaN(Number(patientAge))) {
      notification.warning({ message: "Please enter a valid age" });
      return;
    }

    setBookingLoading(true);
    try {
      const isToday = selectedDateStr === moment().format("YYYY-MM-DD");

      const response = await axiosInstance.post("doctor/insert_patient_walkin", {
        mobile_no: patientPhone,
        name: patientName,
        age: Number(patientAge) || 0,
        gender: gender,
        book_date: selectedDateStr,
        from_time: selectedSlot.from_time,
        to_time: selectedSlot.to_time,
        service_type_id: selectedService.id,
        book_amount: selectedService.cost,
        payment_status: 0,
        clinic_id: Cookies.get("Clinic_id"),
        doctor_id: selectedDoctor.doctor_id,
        created_by: Cookies.get("Doctor_id") || selectedDoctor.doctor_id,
        total_slots: slots.length,
        arrived_status: isToday ? "1" : "0",
        arrived_order_list: isToday ? moment().format("HH:mm:ss") : "NULL",
      });

      if (response.data.status === 1) {
        setShowSuccess(true);
      } else {
        notification.error({ message: response.data.msg || "Failed to book appointment" });
      }
    } catch (error) {
      console.error("Booking failed", error);
      notification.error({ message: "Internal server error" });
    } finally {
      setBookingLoading(false);
    }
  };

  const resetForm = () => {
    setShowSuccess(false);
    setPatientName("");
    setPatientPhone("");
    setPatientAge("");
    setGender("");
    setSelectedSlot(null);
    setShowSearchResults(false);
    fetchSlots();
  };

  const currency = "₹";
  const getServiceCost = (s) => s ? Number(s.int_rate || s.cost || s.consultation_fee || s.fee || 0) : 0;
  const feeAmount = getServiceCost(selectedService).toFixed(2);

  return (
    <div className="space-y-3 animate-in fade-in duration-300 w-full text-gray-800">
      {/* Integrated Header Bar */}
      <div className="bg-white px-3.5 py-2.5 rounded-lg border border-gray-200 shadow-2xs flex flex-col sm:flex-row sm:items-center justify-between gap-2.5">
        <div className="flex items-center gap-2.5">
          <button
            onClick={() => history.push("/dashboard/appointments")}
            className="p-1 hover:bg-gray-100 rounded text-gray-400 transition-colors"
            title="Back to Appointments"
          >
            <HiOutlineChevronLeft size={18} />
          </button>
          <div>
            <h2 className="text-sm font-bold text-gray-800 leading-tight flex items-center gap-1.5">
              Walk-in <span className="text-teal-600">Booking</span>
            </h2>
            <p className="text-gray-400 text-[11px]">
              Create immediate on-site appointments for walk-in patients
            </p>
          </div>
        </div>

        {/* Total Fee Indicator */}
        <div className="flex items-center gap-3 bg-teal-50/80 border border-teal-100 px-3 py-1 rounded-lg self-start sm:self-auto">
          <div className="text-right">
            <span className="text-[9px] font-bold uppercase tracking-wider text-teal-600 block">Consultation Fee</span>
            <div className="text-base font-bold text-teal-800 leading-none">
              {currency} {feeAmount}
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 items-start">
        <div className="lg:col-span-7 bg-white p-3.5 rounded-lg border border-gray-200 shadow-2xs space-y-3">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5">
            <div className="space-y-1">
              <label className="block text-[11px] font-bold text-gray-600 mb-1 uppercase tracking-wider">Doctor</label>
              <Select
                className="w-full"
                style={{ height: '32px' }}
                placeholder="Select Doctor"
                value={selectedDoctor?.doctor_id}
                onChange={(val) => {
                  setSelectedDoctor(doctors.find(d => d.doctor_id === val));
                  setSelectedService(null);
                  setSelectedSlot(null);
                }}
              >
                {doctors.map(d => (
                  <Option key={d.doctor_id} value={d.doctor_id}>{d.doctorName}</Option>
                ))}
              </Select>
            </div>

            <div className="space-y-1">
              <label className="block text-[11px] font-bold text-gray-600 mb-1 uppercase tracking-wider">Service</label>
              <Select
                className="w-full"
                style={{ height: '32px' }}
                placeholder="Select Service"
                optionLabelProp="label"
                value={selectedService?.id}
                onChange={(val) => {
                  setSelectedService(services.find(s => s.id === val));
                  setSelectedSlot(null);
                }}
              >
                {services.map(s => (
                  <Option
                    key={s.id}
                    value={s.id}
                    label={s.service}
                  >
                    <div className="flex justify-between items-center w-full pr-1 text-xs">
                      <span className="font-semibold">{s.service}</span>
                      <span className="text-teal-600 font-bold">{currency} {getServiceCost(s).toFixed(2)}</span>
                    </div>
                  </Option>
                ))}
              </Select>
            </div>

            <div className="space-y-1">
              <label className="block text-[11px] font-bold text-gray-600 mb-1 uppercase tracking-wider">Date</label>
              <input
                type="date"
                min={moment().format("YYYY-MM-DD")}
                value={selectedDateStr}
                onChange={(e) => {
                  if (e.target.value) {
                    setSelectedDateStr(e.target.value);
                    setSelectedSlot(null);
                  }
                }}
                className="w-full px-2.5 py-1 rounded-md bg-white border border-gray-200 text-xs font-semibold text-gray-700 outline-none focus:border-teal-500 transition-all cursor-pointer"
                style={{ height: '32px' }}
              />
            </div>
          </div>

          <div className="space-y-2 pt-2 border-t border-gray-100">
            <div className="flex items-center justify-between">
              <h3 className="text-xs font-bold text-gray-700">Available Slots</h3>
              <div className="flex gap-2.5">
                <div className="flex items-center gap-1 text-[10px] font-bold text-teal-600 uppercase">
                  <span className="w-1.5 h-1.5 rounded-full bg-teal-500" />
                  Available
                </div>
                <div className="flex items-center gap-1 text-[10px] font-bold text-gray-400 uppercase">
                  <span className="w-1.5 h-1.5 rounded-full bg-gray-300" />
                  Booked
                </div>
              </div>
            </div>

            <div className="bg-gray-50/50 rounded-lg border border-dashed border-gray-200 min-h-[160px] flex items-center justify-center p-2.5 relative overflow-hidden">
              {loading ? (
                <div className="text-center">
                  <Spin size="small" />
                  <p className="text-gray-400 text-[10px] font-bold uppercase tracking-wider mt-1.5">Generating timeline...</p>
                </div>
              ) : slots.length > 0 ? (
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-1.5 w-full">
                  {slots.map((slot, idx) => (
                    <button
                      key={idx}
                      type="button"
                      disabled={slot.disabled}
                      onClick={() => !slot.disabled && setSelectedSlot(slot)}
                      className={`h-8 rounded-md text-[11px] font-bold transition-all border flex flex-col items-center justify-center cursor-pointer ${
                        slot.disabled
                          ? 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed line-through'
                          : selectedSlot?.from_time === slot.from_time
                          ? 'bg-teal-600 border-teal-600 text-white shadow-2xs'
                          : 'bg-white border-gray-200 text-gray-700 hover:border-teal-400 hover:text-teal-600'
                      }`}
                      title={slot.reason || 'Available'}
                    >
                      <span className="font-mono">{moment(slot.from_time, "HH:mm:ss").format("hh:mm A")}</span>
                    </button>
                  ))}
                </div>
              ) : (
                <div className="flex flex-col items-center text-center py-4">
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<span className="text-xs text-gray-400 font-medium">No slots available for selected date</span>} />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="lg:col-span-5 bg-white p-3.5 rounded-lg border border-gray-200 shadow-2xs space-y-2.5">
          <div className="flex items-center justify-between pb-1.5 border-b border-gray-100">
            <h3 className="text-xs font-bold text-gray-700">Patient Information</h3>
            {patientPhone && (
              <button
                type="button"
                onClick={() => handlePatientSearch(patientPhone || patientName)}
                className="text-[11px] font-bold text-teal-600 hover:underline flex items-center gap-1 cursor-pointer"
              >
                <HiOutlineSearch size={12} /> Search
              </button>
            )}
          </div>

          <div className="space-y-1 relative">
            <label className="block text-[11px] font-bold text-gray-600 uppercase tracking-wider">
              Mobile Number
            </label>
            <div className="relative">
              <Input
                placeholder="Enter mobile number"
                prefix={<HiOutlinePhone className="text-gray-400 mr-1" size={13} />}
                value={patientPhone}
                maxLength={12}
                onChange={(e) => handlePhoneChange(e.target.value)}
                className="rounded-md border-gray-200 bg-white font-semibold text-xs"
                style={{ height: '32px' }}
              />
              {isSearching && (
                <div className="absolute right-3 top-2">
                  <Spin size="small" />
                </div>
              )}
            </div>

            {showSearchResults && searchResults.length > 0 && (
              <div className="absolute z-50 left-0 right-0 top-[56px] bg-white rounded-lg shadow-lg border border-gray-200 p-1 max-h-48 overflow-y-auto space-y-0.5">
                <div className="text-[9px] font-bold uppercase tracking-wider text-gray-400 px-2 py-1">
                  Existing Patients ({searchResults.length})
                </div>
                {searchResults.map((p, pIdx) => (
                  <div
                    key={pIdx}
                    onClick={() => selectExistingPatient(p)}
                    className="px-2.5 py-1.5 rounded hover:bg-teal-50 text-xs cursor-pointer flex items-center justify-between transition-colors"
                  >
                    <div>
                      <div className="font-bold text-gray-800 text-xs">{p.patient_name || p.name}</div>
                      <div className="text-gray-400 text-[10px] font-mono">{p.patient_mobile || p.phone_no}</div>
                    </div>
                    <div className="text-right text-[10px] text-teal-700 font-bold">
                      {p.gender || ""}{p.age ? `, ${p.age} yrs` : ""}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="space-y-1">
            <label className="block text-[11px] font-bold text-gray-600 uppercase tracking-wider">Full Name</label>
            <Input
              placeholder="Enter patient name"
              prefix={<HiOutlineUser className="text-gray-400 mr-1" size={13} />}
              value={patientName}
              onChange={(e) => {
                setPatientName(e.target.value);
                if (e.target.value.length >= 3) {
                  handlePatientSearch(e.target.value);
                }
              }}
              className="rounded-md border-gray-200 bg-white font-semibold text-xs"
              style={{ height: '32px' }}
            />
          </div>

          <div className="grid grid-cols-2 gap-2">
            <div className="space-y-1">
              <label className="block text-[11px] font-bold text-gray-600 uppercase tracking-wider">Age (Yrs)</label>
              <Input
                type="number"
                min="1"
                max="120"
                placeholder="e.g. 28"
                value={patientAge}
                onChange={(e) => setPatientAge(e.target.value)}
                className="rounded-md border-gray-200 bg-white font-semibold text-xs"
                style={{ height: '32px' }}
              />
            </div>

            <div className="space-y-1">
              <label className="block text-[11px] font-bold text-gray-600 uppercase tracking-wider">Gender</label>
              <div className="flex border border-gray-200 rounded-md overflow-hidden bg-gray-50 p-0.5" style={{ height: '32px' }}>
                <button
                  type="button"
                  onClick={() => setGender('M')}
                  className={`flex-1 rounded font-bold text-xs uppercase transition-all flex items-center justify-center cursor-pointer ${gender === 'M' ? 'bg-white text-teal-600 shadow-2xs border border-gray-200' : 'text-gray-400'}`}
                >
                  Male
                </button>
                <button
                  type="button"
                  onClick={() => setGender('F')}
                  className={`flex-1 rounded font-bold text-xs uppercase transition-all flex items-center justify-center cursor-pointer ${gender === 'F' ? 'bg-white text-teal-600 shadow-2xs border border-gray-200' : 'text-gray-400'}`}
                >
                  Female
                </button>
              </div>
            </div>
          </div>

          <div className="pt-2">
            <button
              disabled={bookingLoading || !selectedSlot}
              onClick={handleBooking}
              className={`w-full h-8.5 bg-teal-600 hover:bg-teal-700 text-white rounded-lg flex items-center justify-center gap-1.5 transition-all shadow-2xs font-bold text-xs cursor-pointer ${(!selectedSlot || bookingLoading) ? 'opacity-50 grayscale cursor-not-allowed' : ''}`}
            >
              {bookingLoading ? (
                <Spin className="invert" size="small" />
              ) : (
                <>
                  <HiOutlineCheckCircle size={15} />
                  <span>Confirm Booking</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      <Modal
        visible={showSuccess}
        footer={null}
        closable={false}
        centered
        width={400}
        bodyStyle={{ padding: '40px 30px', textAlign: 'center', borderRadius: '30px' }}
      >
        <div className="w-16 h-16 bg-teal-50 rounded-full flex items-center justify-center mx-auto mb-6">
          <HiOutlineCheckCircle className="text-[#14948a]" size={40} />
        </div>
        <h2 className="text-2xl font-black text-gray-900 mb-2 tracking-tight">Booking Saved</h2>
        <p className="text-gray-400 mb-8 text-xs font-bold leading-relaxed">
          The appointment has been successfully secured and the patient has been added to the clinic queue.
        </p>

        <div className="space-y-3">
          <button
            className="w-full h-12 bg-[#14948a] text-white rounded-xl font-black text-xs uppercase tracking-widest shadow-md transition-all hover:bg-[#117d74] cursor-pointer"
            onClick={() => history.push("/dashboard/queue")}
          >
            Manage Queue
          </button>
          <button
            className="w-full h-12 bg-gray-50 text-gray-600 rounded-xl font-black text-xs uppercase tracking-widest hover:bg-gray-100 transition-all cursor-pointer"
            onClick={resetForm}
          >
            New Booking
          </button>
        </div>
      </Modal>
    </div>
  );
}

export default WalkInBookingComponent;
